import React from "react";
import "../../../assets/css/user/whytime4pulse/WhyTime4Pulse.css";


const features = [
  {
    id: 1,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="#6B7DB3" strokeWidth="1.8" />
        <polyline points="12 7 12 12 15 14" stroke="#6B7DB3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "Real-Time Deals",
    description: "Instant deals appear in real-time with countdown timers",
  },
  {
    id: 2,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L4 5v6c0 5.25 3.5 10.15 8 11.35C16.5 21.15 20 16.25 20 11V5L12 2z" stroke="#6B7DB3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <polyline points="9 12 11 14 15 10" stroke="#6B7DB3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "Verified Sellers",
    description: "All shops are KYC verified for your safety",
  },
  {
    id: 3,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="#6B7DB3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "Quick Booking",
    description: "Book and avail deals with just one tap",
  },
  {
    id: 4,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" stroke="#6B7DB3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "Top Rated",
    description: "Community-driven ratings ensure quality",
  },
];

export default function WhyTime4Pulse() {
  return (
    <section className="wtp-section">
      <div className="wtp-header">
        <h2 className="wtp-title">Why Time4Pulse?</h2>
        <p className="wtp-subtitle">The smartest way to discover and grab deals</p>
      </div>

      <div className="wtp-features">
        {features.map((feature) => (
          <div className="wtp-feature" key={feature.id}>
            <div className="wtp-icon-wrap">
              {feature.icon}
            </div>
            <h3 className="wtp-feature-title">{feature.title}</h3>
            <p className="wtp-feature-desc">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}